import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactComponent as BCHLogoSOP } from '../images/BCH-logo-SOP.svg';
import { Link } from 'react-router-dom';

class Header extends React.Component {
  render() {
    return (
      <Box sx={styles.headerStyle}>
        <Link to="/">
          <BCHLogoSOP />
        </Link>
        <Box sx={styles.rightItemStyle}>
          <Typography variant="body2" sx={styles.rightItemTextStyle}>
            Call +1-844-354-2160 8am-5pm EST
          </Typography>
        </Box>
      </Box>
    );
  }
}

const styles = {
  headerStyle: {
    backgroundColor: '#003087',
    height: 90,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '25px'
  },
  leftItemStyle: {
    height: 100,
    ml: 2
  },
  rightItemStyle: {
    mr: 2
  },
  rightItemTextStyle: {
    color: '#FFFFFF'
  }
};

export default Header;
